import TransportRateList from '@/components/TransportRate/TransportRateList'
import TransportRateForm from '@/components/TransportRate/TransportRateForm'

let TransportRateRouter = [{
  path: '/transport-rate',
  name: 'TransportRateList',
  component: TransportRateList,
  meta: {
    title: 'Barème transport',
    requiresAuth: true,
    authorizations: ['transport-rate_index', 'desktop_access']
  }
}, {
  path: '/transport-rate/new',
  name: 'TransportRateNew',
  component: TransportRateForm,
  meta: {
    title: 'Nouveau barème transport',
    requiresAuth: true,
    authorizations: ['transport-rate_new', 'desktop_access']
  }
}, {
  path: '/transport-rate/:id/edit',
  name: 'TransportRateEdit',
  component: TransportRateForm,
  meta: {
    title: 'Modifier un barème transport',
    requiresAuth: true,
    authorizations: ['transport-rate_edit', 'desktop_access']
  }
}]

export default TransportRateRouter



// WEBPACK FOOTER //
// ./src/components/TransportRate/router.js